<div class="toolbar-container">
  <div class="results-count">
    Showing <strong>{{ start }} - {{ end }}</strong> of <strong>{{ total }}</strong> results
  </div>

  <!-- Mobile Filter Toggle Button -->
  <button class="filter-toggle-btn" (click)="onFilterToggle()" aria-label="Toggle Filters">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 6H20M4 12H20M4 18H20"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
    <span>Filters</span>
  </button>

  <div class="toolbar-actions">
    <!-- View Toggle -->
    <div class="view-toggle">
      <button
        [class.active]="viewMode === 'grid'"
        (click)="onViewChange('grid')"
        aria-label="Grid View"
      >
        <!-- SVG Icon for Grid -->
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 10H3V3H10V10ZM21 10H14V3H21V10ZM10 21H3V14H10V21ZM21 21H14V14H21V21Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <button
        [class.active]="viewMode === 'list'"
        (click)="onViewChange('list')"
        aria-label="List View"
      >
        <!-- SVG Icon for List -->
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Sort Dropdown -->
    <div class="sort-dropdown">
      <select (change)="onSortChange($event)">
        <option
          *ngFor="let opt of sortOptions"
          [value]="opt.value"
          [selected]="opt.value === currentSort"
        >
          {{ opt.label }}
        </option>
      </select>
    </div>
  </div>
</div>
